<style lang="scss">
	.search-bar {
		position: relative;
		z-index: 10;
		.hero {
			height: 600px;
			background-position: 50% 60%;
			background-repeat: no-repeat;
			background-size: cover;
			display: flex;
			align-items: center;
			flex-direction: column;
			justify-content: center;
			h1 {
				color: #fff;
				margin-bottom: 25px;
				font-size: 50px;
				font-weight: 600;
				letter-spacing: 0.1px;
				text-shadow: rgba(0, 0, 0, 0.39) 2px 2px;
			}
		}
		.search-input-wrapper {
			position: relative;
			width: 100%;
			max-width: 100%;
			padding: 0 1.5rem;
		}
		.search-input {
			border-radius: 5px;
			height: 60px;
			padding-left: 40px;
			background-color: var(--searchbar-background-color) !important;
			color: var(--searchbar-text-color) !important;
			border-color: var(--searchbar-border-color) !important;

			&:focus {
				border-radius: 5px !important;
				background-color: var(--searchbar-background-color);
				color: var(--searchbar-text-color);
				border-color: var(--searchbar-border-color);
				outline: none;
				box-shadow: inset 0 0 0 rgba(0, 0, 0, 0.075), 0 0 10px var(--searchbar-border-color);
			}

			&::placeholder {
				color: var(--searchbar-placeholder-color);
			}
		}
		.search-icon {
			position: absolute;
			left: 37px;
			top: 20px;
			color: var(--searchbar-text-color);
			font-size: 18px;
		}
		.search-clear {
			position: absolute;
			right: 35px;
			top: 22px;
			cursor: pointer;
			color: rgba(221, 8, 8, 0.7);
			font-size: 18px;
		}
		.search-input-wrapper.search-only {
			margin: auto;
			padding: 40px 1.5rem 0px;
			.search-icon {
				top: 60px;
				left: 36px;
			}
			.search-clear {
				top: 63px;
				right: 36px;
			}
		}

		@media screen and (max-width: 1200px) {
			.hero {
				height: 370px;
			}
		}

		@media screen and (max-width: 991px) {
			.hero {
				h1 {
					font-size: 40px;
				}
			}
			.search-input-wrapper {
				padding: 0 1rem;
				.search-icon {
					left: 29px;
				}
			}
			.search-input-wrapper.search-only {
				padding-left: 1rem;
				padding-right: 1rem;
				.search-icon {
					left: 30px;
				}
			}
		}
		@media screen and (max-width: 768px) {
			.hero {
				height: 250px;
				h1 {
					font-size: 30px;
				}
				.search-input {
					height: 45px;
				}
				.search-icon {
					top: 12px;
				}
				.search-clear {
					right: 25px;
					top: 15px;
					font-size: 17px;
				}
			}
			.search-input-wrapper.search-only {
				padding-top: 25px;
				.search-input {
					height: 45px;
				}
				.search-icon {
					top: 39px;
				}
				.search-clear {
					top: 41px;
				}
			}
		}
		@media screen and (max-width: 550px) {
			.hero {
				height: 200px;
				h1 {
					font-size: 18px;
					margin-bottom: 15px;
				}
			}
		}
		@media screen and (max-width: 350px) {
			.hero {
				h1 {
					font-size: 16px;
				}
			}
		}
		.search-input-fixed-width {
			width: 1000px !important;
		}
	}
</style>

<template>
	<div v-if="display" class="search-bar" :style="searchbarStyles">
		<div v-if="display == 'hero'" class="hero" :style="{ 'background-image': 'url(' + heroUrl + ')' }">
			<h1 :style="$heroTitle">{{ config.heroTitle }}</h1>
			<div class="search-input-wrapper" :class="{'search-input-fixed-width': !pageFullWidth}">
                <form novalidate @submit="search">
                    <input type="text" name="search" class="search-input form-control" v-model="searchQuery" placeholder="Search Music">
                </form>
				<span class="search-icon"><font-awesome-icon :icon="['far', 'search']"></font-awesome-icon></span>
				<span class="search-clear" @click="clearSearch" v-if="searchQuery.length > 0"><font-awesome-icon :icon="['fal', 'times-circle']"></font-awesome-icon></span>
			</div>
		</div>

		<div v-else-if="display == 'search'">
			<div class="search-input-wrapper search-only" :class="{'search-input-fixed-width': !pageFullWidth}">
                <form novalidate @submit="search">
				    <input type="text" name="search" class="search-input form-control" v-model="searchQuery" placeholder="Search Music">
                </form>
				<span class="search-icon"><font-awesome-icon :icon="['far', 'search']"></font-awesome-icon></span>
				<span class="search-clear" @click="clearSearch" v-if="searchQuery.length > 0"><font-awesome-icon :icon="['fal', 'times-circle']"></font-awesome-icon></span>
			</div>
		</div>
	</div>
</template>

<script>
	import Beat from '../models/beat'
	import SoundKit from '../models/soundkit'
    import Configure from '../mixins/configure'

	export default {
		props: ['display'],
        mixins: [Configure],
		computed: {
      currentPageType() {
        return this.$store.state.currentPage?.type
      },
			searchQuery: {
				get() {
					return this.$store.state.search
				},
				set(value) {
					this.$store.commit("searchQuery", {searchQuery: value})
				},
				config() {
				    return this.$store.state.currentConfig
				}
			},
            config() {
                return this.$store.state.currentConfig
            },
            heroUrl () {
				var lookup = 'default.jpg'
				var profileCover = new RegExp("\\b" + lookup + "\\b").test(ab.user.profile.cover)
				var infinitycover = new RegExp("\\b" + lookup + "\\b").test(this.config.hero)
				return ((profileCover && infinitycover) || (!infinitycover)) ? this.config.hero : ab.user.profile.cover
			},
			pageFullWidth() {
                if (this.$store.state.currentPage) {
                    return this.$store.state.currentPage.page_full_width
                }
			},
            searchbarStyles() {
				if (this.display == 'hero') {
					return {
						'--searchbar-background-color': this.config.stylesConfig.main.searchbar_input_background.value,
						'--searchbar-placeholder-color': this.config.stylesConfig.main.searchbar_input_placeholder_text.value,
						'--searchbar-text-color': this.config.stylesConfig.main.searchbar_input_text.value,
						'--searchbar-border-color': this.config.stylesConfig.main.searchbar_input_border.value,
					}
				}

                return {
                    '--searchbar-background-color': this.config.stylesConfig.main.input_background.value,
                    '--searchbar-placeholder-color': this.config.stylesConfig.main.input_placeholder_text.value,
                    '--searchbar-text-color': this.config.stylesConfig.main.input_text.value,
                    '--searchbar-border-color': this.config.stylesConfig.main.input_border.value,
                }
            }
		},
		methods: {
		 //    search() {
   //              if (this.searchQuery.length > 2 && this.config.defaultBeatsPage) {
   //                  this.$router.push({path: this.config.defaultBeatsPage.link, query: {q: this.searchQuery}})
   //              }
			// },
		    search(event) {
                event?.preventDefault()
                if (this.searchQuery.length > 2) {
                    this.$router.push({path: '/search', query: {q: this.searchQuery, from: this.currentPageType}})
                }
			},
			clearSearch() {
				this.$store.commit("searchQuery", {searchQuery: ""})

				if (this.$route.name === "search") {
          const from = this.$route.query?.from
          if (from && ['beats', 'soundkits', 'songs'].includes(from)) {
            // Go to previous page
            const { path } = this.$router.options.routes.find((option) => option.meta?.type === from)
            this.$router.push( {path})
          } else {
            let path = this.config.defaultBeatsPage?.link ?? "/"
            this.$router.push({path: path, query: {}})
          }
				} else {
				    this.$router.push({path: this.$route.path, query: {}})
				}
            }
		}
	}
</script>
